
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.445 10.39l1.14-2.82H.454V6.531h3.524l.898-2.203H.453V3.29h4.813L6.39.47h.906l-1.149 2.82H9.54L8.281 1.781l.508-.43 3.82 3.82v.5L8.79 9.493l-.508-.43 1.25-1.492H4.47l-1.117 2.82h-.907zm3.313-6.062l-.899 2.203h5.47l.898-1.11-.883-1.093H5.758z","fill":"currentColor"}})])
          )
        }
      }
    